<template>
	<v-dialog
		v-if="showDialog"
		v-model="visible"
		max-width="500"
		persistent
		tyle="z-index:20001;"
	>
		<v-container class="fill-height justify-center" tag="section">
			<v-row justify="center">
				<v-slide-y-transition appear>
					<base-material-card
						class="px-5 py-3"
						color="success"
						light
						max-width="100%"
						width="500"
					>
						<template v-slot:heading>
							<div class="text-center">
								<span class="text-h2 mb-2"> IRIS </span>
								<span class="text-h2 font-weight-thin"
									>Asset Web Portal</span
								>
							</div>
							<div class="text-center">
								<span class="text font-weight-thin">
									{{ applicationVersion }}
								</span>
							</div>
						</template>

						<v-card-text class="text-center">
							<div
								class="text-center grey--text text-body-1 font-weight-light"
							>
								In order to continue, please re-enter your
								credentials
							</div>

							<v-form
								ref="form_FormsLogin"
								v-if="
									selectedLoginMethod ===
									irisLoginMethod.Forms
								"
							>
								<v-select
									label="Login Method"
									:items="loginMethods"
									v-model="selectedLoginMethod"
									:rules="[rules.required]"
								>
									<template v-slot:selection="{ item }">
										{{ getLoginMethod(item) }}
									</template>
									<template v-slot:item="{ item }">
										{{ getLoginMethod(item) }}
									</template>
								</v-select>

								<v-text-field
									ref="Email"
									v-model="Email"
									:rules="[rules.required, rules.email]"
									disabled
									color="secondary"
									label="Email..."
									prepend-icon="mdi-email"
								/>

								<v-text-field
									ref="Password"
									v-model="Password"
									:append-icon="
										show ? 'mdi-eye' : 'mdi-eye-off'
									"
									:rules="[rules.required]"
									:type="show ? 'text' : 'password'"
									class="mb-4"
									color="secondary"
									label="Password..."
									prepend-icon="mdi-lock-outline"
									@click:append="togglePassVisibility"
									@keydown.enter="onOk"
								/>

								<div
									class="text-center error--text text-body-1 font-weight-light mb-4"
								>
									<span v-if="authError"
										>Invalid Email or Password</span
									>
								</div>
							</v-form>

							<v-form
								ref="form_WindowsLogin"
								v-if="
									selectedLoginMethod ===
									irisLoginMethod.Windows
								"
							>
								<v-select
									label="Login Method"
									:items="loginMethods"
									v-model="selectedLoginMethod"
									:rules="[rules.required]"
								>
									<template v-slot:selection="{ item }">
										{{ getLoginMethod(item) }}
									</template>
									<template v-slot:item="{ item }">
										{{ getLoginMethod(item) }}
									</template>
								</v-select>
								<v-text-field
									disabled
									label="Domain \ Username"
									v-model="windowsUsername"
									:rules="[rules.required]"
								/>
								<div
									class="text-center error--text text-body-1 font-weight-light mb-4"
								>
									<span v-if="authError"
										>Windows Authentication Failed</span
									>
								</div>
							</v-form>
							<v-card-actions>
								<v-btn @click="onCancel">Cancel</v-btn>
								<v-spacer />
								<v-btn class="primary" @click="onOk">Ok</v-btn>
							</v-card-actions>
						</v-card-text>
					</base-material-card>
				</v-slide-y-transition>
			</v-row>
		</v-container>
		<v-overlay :value="loading" :dark="false" z-index="10001">
			<v-card max-width="200px">
				<v-card-text class="d-flex justify-center">
					<v-progress-circular
						:size="25"
						indeterminate
						color="primary"
					/>
					<span class="mx-3 text-button">Loading</span>
				</v-card-text>
			</v-card>
		</v-overlay>
	</v-dialog>
</template>

<script>
import httpClientService from '../../../services/httpClientService';
import jwtDecode from 'jwt-decode';
import appVersion from '../../../utils/appVersionUtils';
import { IrisLoginMethod } from '../../../enums/irisLoginMethod';

export default {
	name: 'TokenExpireDialogModal',
	props: {
		showDialog: Boolean,
		token: String,
	},
	data() {
		return {
			irisLoginMethod: IrisLoginMethod,
			selectedLoginMethod: null,
			loginMethods: [],
			applicationVersion: appVersion.getVersion(),
			loading: false,
			Email: '',
			Password: '',
			windowsUsername: null,

			visible: true,
			show: false,
			rules: {
				required: (value) => !!value || 'Field is required',
				email: (value) => {
					const pattern =
						/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(value);
				},
			},
			authError: false,
		};
	},

	mounted() {
		this.getLoginMethods();
		if (this.token) {
			this.Email = jwtDecode(this.token).email;
			this.windowsUsername = jwtDecode(this.token).unique_name;
		}
	},

	methods: {
		setSelectedLoginMethod() {
			if (localStorage.last_login_type) {
				this.selectedLoginMethod = JSON.parse(
					localStorage.last_login_type
				);
			} else {
				if (this.loginMethods.length > 0) {
					this.selectedLoginMethod = this.loginMethods[0];
				} else {
					this.selectedLoginMethod = IrisLoginMethod.Forms;
				}
			}
		},
		getLoginMethods() {
			this.loading = true;
			httpClientService
				.GetLoginMethods()
				.then((resp) => {
					this.loginMethods = resp.data;
					this.setSelectedLoginMethod();
				})
				.catch(() => {
					this.authError = true;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		getLoginMethod(value) {
			switch (value) {
				case IrisLoginMethod.Forms:
					return 'Forms';
				case IrisLoginMethod.Windows:
					return 'Windows';
				case IrisLoginMethod.SingleSignOn:
					return 'Single Sing On';
				default:
					return 'Unknown';
			}
		},

		onOk() {
			if (this.selectedLoginMethod == IrisLoginMethod.Forms) {
				this.LoginForms();
			}

			if (this.selectedLoginMethod == IrisLoginMethod.Windows) {
				this.LoginWindows();
			}
		},

		LoginForms() {
			if (!this.$refs['form_FormsLogin'].validate()) return;
			this.loading = true;
			httpClientService
				.Auth({ Email: this.Email, Password: this.Password })
				.then((resp) => {
					this.$emit('confirm', resp.data);
				})
				.catch(() => {
					this.authError = true;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		LoginWindows() {
			if (!this.$refs['form_WindowsLogin'].validate()) return;
			this.loading = true;
			httpClientService
				.AuthWindows()
				.then((resp) => {
					this.$emit('confirm', resp.data);
				})
				.catch(() => {
					this.authError = true;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		togglePassVisibility() {
			this.show = !this.show;
		},
		onCancel() {
			this.$emit('cancel');
		},
	},
};
</script>
<style scoped>
.v-dialog__content {
	z-index: 20002 !important;
}
</style>
